import React from 'react'
import { connect } from 'react-redux'
import GlobalLoadingIndicator from '../components/global-loading-indicator'
import { push } from 'connected-react-router'
import { changeView, views } from '../actions/users'
import RegisterForm from '../components/login-register/register-form'
import ConfirmationForm from '../components/login-register/confirmation-form'

class Login extends React.Component {
  componentWillMount = () => {
    const { dispatch } = this.props

    if (this.props.signedIn) {
      dispatch(push('/'))
    }
  }

  handleViewChange = view => {
    this.props.dispatch(changeView(view))
  }

  render() {
    const { dispatch, signUpError, verificationError, view } = this.props
    // Was defaulting to 0 (login), but it is not handled in switch below
    // hence the 1 (register)
    const viewValue = view || 1

    const renderViewContent = () => {
      const { isFetching, verificationEmail, verificationFetching } = this.props

      if (isFetching) {
        return (
          <div>
            <GlobalLoadingIndicator center />
          </div>
        )
      }

      // here may be coming more content
      switch (viewValue) {
        case views.register:
          return <RegisterForm dispatch={dispatch} error={signUpError} />
        case views.verificationCode:
          return (
            <ConfirmationForm
              dispatch={dispatch}
              email={verificationEmail}
              verificationFetching={verificationFetching}
              error={verificationError}
            />
          )
        default:
          return <div />
      }
    }

    return (
      <div className="row text-center section">
        <div className="col-sm-6 col-sm-offset-3">
          <div className="login-form-container">
            <div className="login-form-window">{renderViewContent()}</div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    isFetching: state.users.isFetching,
    signedIn: state.users.signedIn,
    view: state.users.view,
    verificationEmail: state.users.verificationEmail,
    verificationFetching: state.users.verificationFetching,
    verificationError: state.users.verificationError,
    signUpError: state.users.signUpError
  }
}

export default connect(mapStateToProps)(Login)
